import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs1 from "@mui/material/Tabs";
import Tab1 from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {
  Card,
  Form,
  Button,
  Alert,
  Container,
  Row,
  Col,
  Spinner,
  Tab,
  Tabs,
} from "react-bootstrap";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { useProjectName } from "../../Context/ProjectNameContext";
import { useTranslation } from "react-i18next";
import Plans from "./app/Plans";
import Topup from "./app/Topup";
import { getToken } from "../../utils/auth";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function PlansTopup() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { t, i18n } = useTranslation();


      const handleVisitCount = async () => {
      try {
          const token = getToken();
          const response = await axios.post(
              `${process.env.REACT_APP_URL}/api/stats/module`,
              {
                  moduleType: "deals"
              }, {
              headers: {
                  "Authorization": `Bearer ${token}`,
                  "Content-Type": "application/json"
              }
          }
          );
          
      } catch (error) {
          console.error('Failed Visit count', error);
      }
  
  }
  useEffect(()=>{
      handleVisitCount();
  },[])
  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />

      <div id="content-page" className="content-page">
        <Container>
          <Col lg={12}>
            <Row className="justify-content-center">
              <Col lg={12}>
                <Card className="shadow-sm">
                  <Card.Body>
                    <Box sx={{ width: "100%" }}>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs1
                          value={value}
                          onChange={handleChange}
                          aria-label="basic tabs example"
                          variant="scrollable"
                          scrollButtons="auto"
                        >
                          {/* <Tab1 label={t("Services")} {...a11yProps(0)} />
                          <Tab1 label={t("topup")} {...a11yProps(1)} /> */}
                              <Tab1
      label={
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img src="/plans.jpg" alt="Services" width={20} height={20} />
          {t("Services")}
        </Box>
      }
      {...a11yProps(0)}
    />
    <Tab1
      label={
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img src="/topup.jpg" alt="Topup" width={20} height={20} />
          {t("topup")}
        </Box>
      }
      {...a11yProps(1)}
    />
  </Tabs1>
                      </Box>

                      <CustomTabPanel value={value} index={0}>
                        <Plans />
                      </CustomTabPanel>
                      <CustomTabPanel value={value} index={1}>
                        <Topup />
                      </CustomTabPanel>
                    </Box>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Container>
      </div>
    </>
  );
}
